import * as Immutable from 'immutable';
import _ from 'lodash';

import {
    ADD_SECTION_REQUESTED,
    ADD_SECTION_COMPLETED,
    ADD_SECTION_ERROR,
    REMOVE_SECTION_REQUESTED,
    REMOVE_SECTION_COMPLETED,
    REMOVE_SECTION_ERROR,
    EDIT_SECTION_REQUESTED,
    EDIT_SECTION_COMPLETED,
    EDIT_SECTION_ERROR,
    ADD_ALL_SECTIONS_REQUESTED,
    ADD_ALL_SECTIONS_COMPLETED,
    ADD_ALL_SECTIONS_ERROR,
    REMOVE_ALL_SECTIONS_REQUESTED,
    REMOVE_ALL_SECTIONS_COMPLETED,
    REMOVE_ALL_SECTIONS_ERROR,
    REMOVE_ALL_UNSCOPED_SECTIONS_REQUESTED,
    REMOVE_ALL_UNSCOPED_SECTIONS_COMPLETED,
    REMOVE_ALL_UNSCOPED_SECTIONS_ERROR,
    COPY_TO_CLIPBOARD_REQUESTED,
    COPY_TO_CLIPBOARD_COMPLETED,
    COPY_TO_CLIPBOARD_ERROR,

} from '../../actions/compose-report-tool/types';

const schema = {
    error: null,

    addsectionrequested: false,
    addsectioncompleted: false,
    //
    removesectionrequested: false,
    removesectioncompleted: false,
    //
    selectedsections: [],
    //
    editsectionrequested: false,
    editsectioncompleted: false,
    //
    addallsectionsrequested: false,
    addallsectionscompleted: false,
    //
    removeallsectionsrequested: false,
    removeallsectionscompleted: false,
    //
    removeallunscopedsectionsrequested: false,
    removeallunscopedsectionscompleted: false,
    //
    copytoclipboardrequested: false,
    copytoclipboardcompleted: false,

};

const initialState = Immutable.Map(schema);

const composeReportToolReducer = (state = initialState, action) => {
    switch (action.type) {
    case ADD_SECTION_REQUESTED:
        return state
            .set('addsectionrequested', true);

    case ADD_SECTION_COMPLETED:
        return state
            .set('addsectioncompleted', true)
            .set('selectedsections', state.get('selectedsections').concat(action.payload));
    case ADD_SECTION_ERROR:
        return state
            .set('addsectionrequested', false)
            .set('error', action.payload);

    case ADD_ALL_SECTIONS_REQUESTED:
        return state
            .set('addallsectionsrequested', true);

    case ADD_ALL_SECTIONS_COMPLETED:
        return state
            .set('addallsectionscompleted', true)
            .set('selectedsections', _.unionBy(state.get('selectedsections'), action.payload, 'slug'));

    case ADD_ALL_SECTIONS_ERROR:
        return state
            .set('addallsectionsrequested', false)
            .set('error', action.payload);

    case REMOVE_ALL_SECTIONS_REQUESTED:
        return state
            .set('removeallsectionsrequested', true);

    case REMOVE_ALL_SECTIONS_COMPLETED:
        return state
            .set('removeallsectionscompleted', true)
            .set('selectedsections', []);

    case REMOVE_ALL_SECTIONS_ERROR:
        return state
            .set('removeallsectionsrequested', false)
            .set('error', action.payload);

    case REMOVE_ALL_UNSCOPED_SECTIONS_REQUESTED:
        return state
            .set('removeallunscopedsectionsrequested', true);

    case REMOVE_ALL_UNSCOPED_SECTIONS_COMPLETED:
        return state
            .set('removeallunscopedsectionscompleted', true)
            .set('selectedsections', action.payload);
    case REMOVE_ALL_UNSCOPED_SECTIONS_ERROR:
        return state
            .set('removeallunscopedsectionsrequested', false)
            .set('error', action.payload);

    case REMOVE_SECTION_REQUESTED:
        return state
            .set('removesectionrequested', true);

    case REMOVE_SECTION_COMPLETED:
        return state
            .set('removesectioncompleted', true)
            .set('selectedsections', state.get('selectedsections').filter((item) => item.slug !== action.payload));

    case REMOVE_SECTION_ERROR:
        return state
            .set('removesectionrequested', false)
            .set('error', action.payload);

    case EDIT_SECTION_REQUESTED:
        return state
            .set('editsectionrequested', true);

    case EDIT_SECTION_COMPLETED:
        return state
            .set('editsectioncompleted', true)
            .set('selectedsections', state.get('selectedsections').map((item) => {
                const newItem = item;
                if (newItem.slug === action.payload.slug) {
                    newItem.content = action.payload.content;
                }
                return newItem;
            }));

    case EDIT_SECTION_ERROR:
        return state
            .set('editsectionrequested', false)
            .set('error', action.payload);

    case COPY_TO_CLIPBOARD_REQUESTED:
        return state
            .set('copytoclipboardrequested', true);

    case COPY_TO_CLIPBOARD_COMPLETED:
        return state
            .set('copytoclipboardrequested', false)
            .set('copytoclipboardcompleted', true);

    case COPY_TO_CLIPBOARD_ERROR:
        return state
            .set('copytoclipboardrequested', false)
            .set('copytoclipboardcompleted', true)
            .set('error', action.payload);

    default:
        return state;
    }
};

export { initialState };

export default composeReportToolReducer;
